import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import { trackEvent } from '../../utils/analytics';
import { HOME_ROUTE_KEY } from '../../utils/sessionStorageKeys';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();
  
  // Ne pas afficher le bouton home sur les pages d'accueil
  const isHomePage = location.pathname === '/' || location.pathname === '/onSite';

  const handleHomeClick = () => {
    trackEvent('home_button_click', {
      event_category: 'navigation',
      event_label: 'Return to Home',
      from_page: location.pathname,
    });
    const homeRoute = sessionStorage.getItem(HOME_ROUTE_KEY) || '/';
    navigate(homeRoute);
  };

  return (
    <div className={`app-header ${isHomePage ? 'home-header' : ''}`}>
      {!isHomePage && (
        <button className="home-button" onClick={handleHomeClick} aria-label={t('home') || 'Home'}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
          <span className="home-button-text">{t('aquaFarina')}</span>
        </button>
      )}
      <LanguageSelector />
    </div>
  );
};

export default Header;



